import { ApiReturnPageConfig } from '@highimpact-frontend/api-types';
import { useEffect, useState } from 'react';
import { api_config } from '../../api/api-commons';
import ContextualDashboardRoute from '../../dashboard/ContextualDashboardRoute';
import ContextFreeDashboardRoute from '../../dashboard/ContextFreeDashboardRoute';

const MicrofrontendHome: React.FC<{
  url: string;
  searchParams: Record<string, string | number>;
}> = ({ url, searchParams }) => {
  const query = new URLSearchParams(
    searchParams as Record<string, string>
  ).toString();
  return (
    <iframe
      src={`${url}?${query}`}
      style={{ width: '100%', height: '100%', border: 'none' }}
      title="Microfrontend"
    />
  );
};

type HomePageState =
  | { status: 'loading' }
  | { status: 'error' }
  | { status: 'component'; Component: React.FC };

export function useHomePage(): HomePageState {
  const [state, setState] = useState<HomePageState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    if (sessionStorage.getItem('DO_NOT_LOAD_HOME_PAGE_CONFIG') === 'true') {
      setState({ status: 'error' });
      return;
    }

    api_config
      .get<ApiReturnPageConfig>('/home-page/config')
      .then((res) => {
        if (cancelled) return;
        const data = res.data;

        if (data.type === 'contextualdashboard') {
          const Wrapped: React.FC = () => (
            <ContextualDashboardRoute
              project_id={data.project_id}
              site_id={data.site_id}
              grid_id={data.dashboard_id}
            />
          );
          setState({ status: 'component', Component: Wrapped });
        } else if (data.type === 'contextfreedashboard') {
          const Wrapped: React.FC = () => (
            <ContextFreeDashboardRoute grid_id={data.dashboard_id} />
          );
          setState({ status: 'component', Component: Wrapped });
        } else if (data.type === 'microfrontend') {
          const Wrapped: React.FC = () => (
            <MicrofrontendHome
              url={data.url}
              searchParams={data.search_params}
            />
          );
          setState({ status: 'component', Component: Wrapped });
        } else {
          setState({ status: 'error' });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setState({ status: 'error' });
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
